import { Card } from '@/components/ui/card';

interface TransportStatsProps {
  stats: {
    totalShipments: string;
    totalTransported: string;
    totalDestinations: string;
    totalLoss: string;
    totalDamage: string;
  };
}

export function TransportStats({ stats }: TransportStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Total Shipments</div>
        <div className="text-2xl font-semibold">{stats.totalShipments}</div>
      </Card>

      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Total Transported</div>
        <div className="text-2xl font-semibold">{stats.totalTransported}</div>
      </Card>

      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Destinations</div>
        <div className="text-2xl font-semibold">{stats.totalDestinations}</div>
      </Card>

      <Card className="p-4">
        <div className="text-sm text-muted-foreground">Loss & Damage</div>
        <div className="text-sm font-medium">
          <div className="text-destructive">Lost: {stats.totalLoss}</div>
          <div className="text-orange-600">Damaged: {stats.totalDamage}</div>
        </div>
      </Card>
    </div>
  );
}
